import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-track-next', 'PlayerTrackNext', [["path",{"d":"M3 5v14l8 -7l-8 -7"}],["path",{"d":"M14 5v14l8 -7l-8 -7"}]]);